import './SingleCaseStudiesV2.scss';
import '../../../Sections/Contact/Contact'
import '../../../Sections/Map/Map'

import SSCV2Nav from './subsections/SSC_Testimonials/SSC_Testimonials'
import CSV2Testimonials from './subsections/SSC_Nav/SSC_Nav'
import AnimatedCounter from '../../../Components/AnimatedCounter/AnimatedCounter'

import FormRedirection from '../../../../common/scripts/FormRedirection';

// NAV
const nav = new SSCV2Nav()
nav.init()

// Testimonials
const CSV2T = new CSV2Testimonials;
CSV2T.init()


// Counters
document.querySelectorAll('[data-animationcount]').forEach(el => {
  const counter = new AnimatedCounter(el);
  counter.init();
});


// Spacging top page
const mainSingleCaseStudies = document.querySelector('.main-SingleCaseStudiesV2');
const navbar = document.getElementById('navbar')

function setTopSpacing() {
  mainSingleCaseStudies.style.paddingTop = `${navbar.offsetHeight}px`;
}
setTopSpacing();
window.onresize = setTopSpacing


FormRedirection.init()
ComponentManager.init(document.body);
